import Toast from "./toast";
import Invoca from "./invoca";

import toastr from "toastr";
import jQuery from "jquery";

const $ = jQuery;

const Flash = {};

Flash.hide = function(useToast) {
  Flash._hideFlashWithFunction('fadeOut', 400, useToast);
  $(window).trigger('resize');
};

Flash.showNotice = function(message, scrollTo, useToast) {
  if (scrollTo === undefined) {
    scrollTo = !useToast;
  }

  Flash._hideFlashWithFunction('hide', useToast);
  Flash._showFlash('notice', message, scrollTo, useToast);
};

Flash.showError = function(message, scrollTo, useToast) {
  if (scrollTo === undefined) {
    scrollTo = !useToast;
  }

  Flash._hideFlashWithFunction('hide', useToast);
  Flash._showFlash('error', message, scrollTo, useToast);
};

// flash private helper methods
Flash._hideFlashWithFunction = function(jqHideMethod, arg, useToast) {
  if (useToast) {
    toastr.clear();
  } else {
    jQuery('#flash-error, #flash-notice')[jqHideMethod](arg, function() {
      $(window).trigger('resize');
    });
  }
};

Flash._showFlash = function(type, message, scrollTo, useToast) {
  if (useToast) {
    Toast[type](message);
  } else {
    var flash = jQuery('#flash-' + type).fadeIn(600);
    flash.children('.flash-content').html(message);

    if (scrollTo) {
      Invoca.smoothScrollTo(flash);
    }
  }

  $(window).trigger('resize');
};

export default Flash;
